const sizesMap = [
  '50x50',
  '65x65',
  '95x95',
  '104x104',
  '110x110',
  '136x136',
  '156x156',
  '165x165',
  '204x204',
  '280x280'
];

const indexIncrementator = 2;

const getResolution = (densities, resolutions, normalDensity) => {
  const result = [];
  densities.map((density, index) => {
    let isCorrectImg = false;
    let correctImgUrl = '';
    resolutions.map(({ size, url }) => {
      if (density[index + 1] <= parseInt(size, 10)
      && parseInt(size, 10) <= normalDensity * (index + indexIncrementator)) {
        isCorrectImg = true;
        correctImgUrl = url;
      }
      return isCorrectImg;
    });
    if (isCorrectImg) {
      result.push(Object.assign(density, { url: correctImgUrl }));
    }
    return result;
  });

  return result;
};

const parseCompanyLogos = (logos) => {
  const densityMobile = [
    { 1: 50, density: 1, url: '' },
    { 2: 100, density: 2, url: '' },
    { 3: 150, density: 3, url: '' },
    { 4: 200, density: 4, url: '' }
  ];
  const densityDesktop = [
    { 1: 65, density: 1, url: '' },
    { 2: 130, density: 2, url: '' },
    { 3: 190, density: 3, url: '' },
    { 4: 260, density: 4, url: '' }
  ];

  const existResolutions = [];
  // eslint-disable-next-line security/detect-object-injection
  sizesMap.map(size => (logos[size] ? existResolutions.push({ size: size.split('x')[0], url: logos[size] }) : null));
  const mobileSize = 50;
  const desktopSize = 65;
  const resultMobile = getResolution(densityMobile, existResolutions, mobileSize);
  const resultDesktop = getResolution(densityDesktop, existResolutions, desktopSize);
  const defaultImage = existResolutions[existResolutions.length - 1] || {
    url: Object.entries(logos).map(([, value]) => value)[0]
  };

  return {
    mobile: {
      images: resultMobile,
      deviceWidth: '360px'
    },
    desktop: {
      images: resultDesktop,
      deviceWidth: '600px'
    },
    defaultImage
  };
};

export default parseCompanyLogos;
